module.exports = __webpack_public_path__ + "images/GenericImagede91932c896ee06bc4c51de0851b62ed.png";